// import axios from "axios"
import { inspectionIarAPI } from "../../axios";
import { inspectionIarItemAPI } from "../../axios";

export const actions = {

    //Inspection IAR
    GetInspectionIar(context, data){
        return inspectionIarAPI.get(`${data}`);
    },
    GetInspectionIarPending(context, data){
        return inspectionIarAPI.get(`Pending/${data.cycle}/${data.campusId}`);
    },
    GetInspectionIarPendingSummary(context, data){
        return inspectionIarAPI.get(`Pending/Summary/${data.cycle}/${data.campusId}`);
    },
    GetInspectionIarPosted(context, data){
        return inspectionIarAPI.get(`Posted/${data.cycle}/${data.campusId}`);
    },
    GetInspectionIarPostedSummary(context, data){
        return inspectionIarAPI.get(`Posted/Summary/${data.cycle}/${data.campusId}`);
    },
    GetInspectionIarCompleted(context, data){
        return inspectionIarAPI.get(`Completed/${data.cycle}/${data.campusId}`);
    },
    GetInspectionIarCompletedSummary(context, data){
        return inspectionIarAPI.get(`Completed/Summary/${data.cycle}/${data.campusId}`);
    },
    GetInspectionIarAvailable(context, data){
        return inspectionIarAPI.get(`Available/${data}`);
    },
    CreateInspectionIar(context, data){
        return inspectionIarAPI.post(`Create`, data);
    },
    CreateAndEmailInspectionIar(context, data){
        return inspectionIarAPI.post(`Create/Email`, data);
    },
    CancelInspectionIar(context, data){
        return inspectionIarAPI.post(`Cancel`, data);
    },
    SubmitInspectionIar(context, data){
        return inspectionIarAPI.post(`Submit/Items`, data);
    },
    DeleteInspectionIar(context, data){
        return inspectionIarAPI.delete(`${data}`);
    },
    UpdateInspectionIar(context, data){
        return inspectionIarAPI.put(`${data.id}`, data);
    },
    UpdateIarNumber(context, data){
        return inspectionIarAPI.post(`Update/IarNumber/${data.id}`, data);
    },
    PostInspectionIar(context, data){
        return inspectionIarAPI.put(`Post/${data.id}`, data);
    },
    UnpostInspectionIar(context, data){
        return inspectionIarAPI.put(`UnPost/${data}`);
    },
    UpdateDRNumber(context, data){
        return inspectionIarAPI.put(`Update/DrNumber/${data.id}`, data);
    },
    SendEmailToCOA(context, data){
        return inspectionIarAPI.post(`SendEmail/${data}`);
    },

    // Iar Item
    CompleteInspectionIarItem(context, data){
        return inspectionIarItemAPI.post(`Complete/${data}`);
    },
    GetInspectionIarItems(context, data){
        return inspectionIarItemAPI.get(`Iar/${data}`);
    },

}